import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchCodes(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('reservation/product-code', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteCode(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`reservation/product-code/${id}/delete`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
